export default __webpack_public_path__ + "static/media/Automation-HSC Transduction - Prodigy vs Manual.ccd6a741.pdf";